import React, { useMemo } from 'react'

import { useIntersection } from '@mantine/hooks'
import { buildComponent } from '../../../../components/factory'
import { Category } from '../../../../state/models/audio'

import * as UI from '@mantine/core'

import { CategoryRow } from './category-row'

interface TableSelectionProps {
  data: Category[]
  toggleRow: (item: string) => void
  isSelected: (item: string) => boolean
}

function sliceArrayIntoPages<T>(arr: T[], size: number): T[][] {
  let step = 0
  const sliceArr: T[][] = []

  while (step < arr.length) {
    sliceArr.push(arr.slice(step, (step += size)))
  }

  return sliceArr
}

const Page = buildComponent<{
  page: Category[]
  isSelected: (item: string) => boolean
  toggleRow: (item: string) => void
}>().withRender(({ props }) => {
  const { ref, entry } = useIntersection()
  const showContent = !!entry?.isIntersecting

  return (
    <div ref={ref} style={{ height: props.page.length * 6 + 'rem' }}>
      {showContent &&
        props.page.map((item) => {
          return (
            <CategoryRow
              key={item._id}
              {...item}
              isSelected={props.isSelected}
              toggleRow={props.toggleRow}
            />
          )
        })}
    </div>
  )
})

export const Table = buildComponent<TableSelectionProps>()
  .withLifecycle(({ props }) => {
    const pages = useMemo(
      () => sliceArrayIntoPages(props.data, 30),
      [props.data],
    )

    return { pages }
  })
  .withRender(({ props, lifecycle }) => {
    if (!props.data.length) {
      return (
        <UI.Group position="center" align="center" sx={{ height: '32rem' }}>
          <UI.Stack align="center" spacing="md">
            <UI.Text size="xl" color="dimmed">
              📂
            </UI.Text>
            <UI.Text color="dimmed" weight={500}>
              Aucune catégorie trouvée
            </UI.Text>
            <UI.Text size="sm" color="dimmed" align="center">
              Il n'y a aucune catégorie configurée qui correspond à vos critères
              de recherche.
            </UI.Text>
          </UI.Stack>
        </UI.Group>
      )
    }

    return (
      <>
        {lifecycle.pages.map((page) => (
          <Page
            key={page.map((c) => c._id).join('-')}
            page={page}
            toggleRow={props.toggleRow}
            isSelected={props.isSelected}
          />
        ))}
      </>
    )
  })
